__turbopack_context__.v({
  "audienceButton": "ChoosePageContent-module__-Wu7Na__audienceButton",
  "audienceButtonText": "ChoosePageContent-module__-Wu7Na__audienceButtonText",
});
